import type { ResourceProps } from '@refinedev/core'
import { i18n } from '../../shared/i18n'

export const cancellationManagementResources: ResourceProps[] = [
  {
    name: 'cancellation-management',
    meta: {
      label: i18n.t('navigation.cancellationManagement.label'),
    },
  },
  {
    name: 'cancellation-list',
    list: '/cancellations',
    show: '/cancellations/:id',
    meta: {
      label: i18n.t('navigation.cancellationManagement.cancellationList'),
      parent: 'cancellation-management',
    },
  },
]
